/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/prefer-hubspot-url-utils */

'use es6';

// TODO: Once #2708 is resolved, use regular import.
// Relevant conversation: https://hubspot.slack.com/archives/C4ABAB8CR/p1596658279222800
// See related: https://git.hubteam.com/HubSpot/asset-bender-hubspot/issues/2708
const {
  bender
} = require('legacy-hubspot-bender-context');
const ENABLED_APP_DOMAINS_PATTERN = /(?:app|local)-?([a-z0-9]+)?.hubspot(?:qa)?.com/;
const domain = document.location.hostname.toLowerCase();
const isAppDomain = ENABLED_APP_DOMAINS_PATTERN.test(domain);
if (isAppDomain) {
  window.hubspot = window.hubspot || {};
  const fireAlarmbundleSrc = `${bender.staticDomainPrefix}${bender.depPathPrefixes[bender.project]}/bundles/loader.js`;
  const page = document.head || document.body;
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = fireAlarmbundleSrc;
  page.appendChild(script);
}